import { render, staticRenderFns } from "./comppricenews.vue?vue&type=template&id=63eeef50"
import script from "./comppricenews.vue?vue&type=script&lang=js"
export * from "./comppricenews.vue?vue&type=script&lang=js"
import style0 from "./comppricenews.vue?vue&type=style&index=0&id=63eeef50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports